import {Injector} from '@angular/core';
import {StateSource, watchState} from '@ngrx/signals';
import {Observable} from 'rxjs';

/**
 * A store's state as an Observable, for the subscribers that still need one: the current state on subscribe, then
 * every update, synchronously (watchState) — what a BehaviorSubject gave them. toObservable() only emits after the
 * next change detection: a `toSignal(…, {requireSync: true})` reader then throws NG0601.
 */
export function stateChanges<State extends object>(store: StateSource<State>, injector: Injector): Observable<State> {
	return new Observable<State>(subscriber => {
		const watcher = watchState(store, state => subscriber.next(state), {injector});
		return () => watcher.destroy();
	});
}
